import React, { useState, useEffect } from "react";
import Slider from "react-slick";

import ViewTriggerSensor from "components/ViewTriggerSensor";

import contentfulApi from "../utils/contentful";
import { featuredNewsCardClicked, featuredNewsCardViewed } from "utils/segment";

import Row from "./Row";
import Col from "./Col";

const PressCarousel = (props) => {
  const [data, setData] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    contentfulApi
      .getEntries({
        content_type: "pressCarousel",
      })
      .then((response) => {
        setData(Object.assign(response.items[0].fields));
        setDataLoaded(true);
      });
  }, [props]);

  if (!dataLoaded) {
    return null;
  }

  return (
    <Slider
      className="press-carousel text-center"
      dots
      infinite
      arrows={false}
      autoplay
      autoplaySpeed={
        data.carouselInterval ? data.carouselInterval * 1000 : 5000
      }
      customPaging={(i) => <div />}
    >
      {data.slides.map((slide, index) => (
        <ViewTriggerSensor
          key={`slide_${index}`}
          onViewTrigger={() => {
            featuredNewsCardViewed({
              headline: slide.fields.quote,
              publication: slide.fields.newsLogo.fields.title,
            });
          }}
        >
          <div
            className="press-carousel__slide direction-row align-stretch"
            style={{ backgorund: "red" }}
          >
            <a
              className="flex align-center"
              href={slide.fields.link}
              target="_blank"
              rel="noopener noreferrer"

              onClick={() => {
                featuredNewsCardClicked({
                  headline: slide.fields.quote,
                  publication: slide.fields.newsLogo.fields.title,
                });
              }}
            >
              <img data-src={`${slide.fields.backgroundImage &&
                `${slide.fields.backgroundImage.fields.file.url}?fm=jpg&q=40`
                }`}
                className="slide-image lazyload"
                alt="News cover"
              />
              <Row className="article" >
                <Col md={{ span: 8, offset: 2 }}>
                  <h4 className="mb-20">{slide.fields.heading}</h4>
                  <h3 className="mb-25">{slide.fields.quote}</h3>

                  <img
                    data-src={slide.fields.newsLogo.fields.file.url + "?w=200"}
                    alt="News"
                    className="img-responsive mr-auto ml-auto lazyload"
                  />
                </Col>
              </Row>
            </a>
          </div>
        </ViewTriggerSensor>
      ))}
    </Slider>
  );
};

export default PressCarousel;
